import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';

const createFaunaOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.fauna.corals', value: '1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.fauna.exotic_fish', value: '2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.fauna.stingrays', value: '3' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.fauna.turtles', value: '4' }),
];

type CreateFaunaFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createFaunaFilters = ({ searchParams, translationDictionary }: CreateFaunaFilters): Filter[] => {
  const showFaunaFilter = isBeachHoliday(searchParams);
  const selectedValues = searchParams[URLParameters.FAUNA]?.split(',') || [];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const faunaFilter: Filter | undefined = showFaunaFilter
    ? {
        name: FILTER_NAME.FAUNA,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createFaunaOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[faunaFilter]].filter((f) => !!f);
};
